import { useState } from 'react';

function usePaymentError(tryAgain) {
    const [errorData, setErrorData] = useState({});

    const handleOnTryAgain = async () => {
        await tryAgain();
        setErrorData({});
    };

    return {
        errorData,
        setErrorData,
        handleOnTryAgain
    };
}

export {
    usePaymentError
};
